import { Injectable } from '@angular/core';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';

@Injectable({
    providedIn: 'root',
})
export class TicketFormattedDataService {
    checkIsAddressData(communityName: string) {
        return (
            communityName === 'bama' ||
            communityName === 'cevita' ||
            communityName === 'gartner' ||
            communityName === 'seleniumtests'
        );
    }

    getAddressData(ticket: DetailedTicketDTO) {
        let clipboardData = (ticket.firstMessageCreator.name || ticket.firstMessageCreator.email) + '\n';

        const address = ticket.fields.find((field) => {
            return field.name.trim() === 'Adresse' || field.name.trim() === 'Address';
        });
        clipboardData += address ? address.value + '\n' : '';

        const zipcode = ticket.fields.find((field) => {
            return field.name.trim() === 'Zipcode';
        });

        clipboardData += zipcode ? zipcode.value : '';

        const city = ticket.fields.find((field) => {
            return field.name.trim() === 'City';
        });

        if (city) {
            clipboardData += zipcode ? ' ' + city.value : city.value;
        }

        clipboardData += ticket.phoneNumber ? '\nTel: ' + ticket.phoneNumber : '';

        return clipboardData;
    }

    getFieldsData(ticket: DetailedTicketDTO) {
        if (ticket.fields.length === 0) {
            return;
        }
        let clipboardData =
            ticket.fields[0].name + ': ' + (ticket.fields[0].transformedValue || ticket.fields[0].value);

        for (let i = 1, length = ticket.fields.length; i < length; i++) {
            clipboardData +=
                '\n' + ticket.fields[i].name + ': ' + (ticket.fields[i].transformedValue || ticket.fields[i].value);
        }
        return clipboardData;
    }
}
